module.exports = __webpack_public_path__ + "img/shield_black.62b45d3e.svg";